import { AxiosInstance } from "axios";
import ApiClient from "src/utils/ApiClient";

let cashedInstance: AxiosInstance | null = null;

const createPermissionsApiClient = () => {
  cashedInstance = new ApiClient({
    baseURL: process.env.REACT_APP_PERMISSIONS_URL || "",
    headers: {},
  }).client;

  cashedInstance.interceptors.response.use((response) => response);

  return cashedInstance;
};

const PermissionsApiClient = {
  get instance() {
    return cashedInstance || createPermissionsApiClient();
  },

  reset() {
    cashedInstance = null;
  },
};

export { PermissionsApiClient };
